/**
 * `<ChatErrorBanner>` — out-of-thread error banner (Y bundle / spec §10.1.a).
 *
 * **Scope: out-of-thread errors only.** In-thread errors (per spec §4.2c —
 * pre-check failures, catch-block errors, runtime cap, user cancel) land
 * in the message list as assistant bubbles, NOT here. This banner is for
 * errors that have no thread context: `loadLatest` GET failures, network
 * errors, auth failures, session-not-found, etc.
 *
 * After Phase 1's "errors with thread context land in thread" rule, the
 * banner's surface area is small — many surfaces may render it never. The
 * primitive exists so surfaces that DO need it look consistent.
 */

import type { JSX } from "react";
import { AiRouteErrorLink } from "../../lib/aiRouteError.js";

export type ChatErrorBannerProps = {
  /** Error text. When null, renders nothing. */
  message: string | null;
  /** ADR-0207: the hub's error code; an AI-route code adds the admin's link to the fix. */
  code?: string | null;
};

export function ChatErrorBanner(props: ChatErrorBannerProps): JSX.Element | null {
  if (!props.message) return null;
  return (
    <div className="help" style={{ color: "var(--danger-text)" }}>
      {props.message}
      {props.code ? (
        <>
          {" "}
          <AiRouteErrorLink code={props.code} />
        </>
      ) : null}
    </div>
  );
}
